import { MRT_ColumnDef } from "material-react-table";
import { Job, Branch } from "../../../../api";
import { ColumnContext, selectColumn } from "./ColumnHelpers";
import { isFieldRequired } from "../../../../utilities/jobValidation";

export function column_Branch(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return selectColumn<Branch>(context, "branchIds", "branch", {
		options: context.props.branches || [],
		freeSolo: false,
		isRequired: () => isFieldRequired("branch", context.validationContext),
		size: 300,
		getOptionLabel: (branch) => branch.name,
		isOptionEqualToValue: (option, value) => option.id === value.id,
		getValue: (job) => (context.props.branches || []).find((branch) => job.branchIds?.includes(branch.id)) || null,
		setValue: (job, branch) => {
			job.branchIds = branch ? [branch.id] : [];
		},
	});
}
